import { Outlet, Navigate } from 'react-router';

export default function ({ hasAccess, authorizedFirstScreen }) {
  return !hasAccess ? <Outlet /> : <Navigate to={authorizedFirstScreen} replace />;
}
